import { flatMap, get, groupBy, map } from 'lodash'

const groupedCustomerData = (terminalServers) => map(
  groupBy(terminalServers, 'customer_name'),
  (assets, customer_name) => ({ customer_name, assets, customer_status: get(assets[0], 'customer_status' )})
)

const groupedDomainData = (terminalServers) => map(
  groupBy(terminalServers, 'domain'),
  (assets, domain) => ({ domain, assets })
)

export { groupedCustomerData, groupedDomainData }
